import { Icon } from '@iconify/react';

export default function InfoCards({ cardsData, estatusActivo, onCardClick, loading, error }) {
  if (loading) return <p>Cargando datos...</p>;
  if (error) return <p className="text-red-500">Error: {typeof error === 'string' ? error : error.message || 'Error inesperado'}</p>;

  const cols = cardsData.length;

  return (
    <div className="flex justify-end">
      <div
        className="grid gap-3 w-full md:w-auto"
        style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}
      >
        {cardsData.map(({ icon, bgColor, textColor, label, value, estatus }, i) => {
          const isActive = estatusActivo === estatus;
          return (
            <div
              key={i}
              onClick={() => onCardClick && onCardClick(isActive ? '' : estatus)}
              className={`
                rounded-md px-3 py-2 flex items-center cursor-pointer transition
                ${bgColor} 
                ${isActive 
                  ? 'bg-opacity-60 shadow-lg scale-105' 
                  : 'bg-opacity-15 hover:bg-opacity-30 hover:scale-105'}
              `}
              style={{ transformOrigin: 'center' }}
            >
              <div className={`
                ${textColor} h-8 w-8 flex items-center justify-center rounded-full bg-white text-xl mr-3
                ${isActive ? 'ring-2 ring-offset-1 ring-' + textColor.replace('text-', '') : ''}
              `}>
                <Icon icon={icon} />
              </div>
              <div className={`leading-tight ${isActive ? 'text-slate-900 font-bold' : 'text-slate-700'}`}>
                <span className="block text-xs font-medium">{label}</span>
                <span className="block text-lg">{value}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
